/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSetViewAllCustomersResponseFromDiscriminatorValue, serializeSetViewAllCustomersRequest, serializeSetViewAllCustomersResponse, type ErrorResponse, type InternalErrorResponse, type SetViewAllCustomersRequest, type SetViewAllCustomersResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/viewallcustomers
 */
export interface ViewallcustomersRequestBuilder extends BaseRequestBuilder<ViewallcustomersRequestBuilder> {
    /**
     * Turns a Sales Rep's org-wide customer visibility on or off. When on, the rep syncs every customer in the organization; when off, only the customers carrying their RepNumber. Intended to be flipped on temporarily (trade shows) and off again — it only moves sync channels and never migrates data.
     * @param body Represents a request to turn a Sales Representative's org-wide customer visibility on or off.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SetViewAllCustomersResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SetViewAllCustomersRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SetViewAllCustomersResponse | undefined>;
    /**
     * Turns a Sales Rep's org-wide customer visibility on or off. When on, the rep syncs every customer in the organization; when off, only the customers carrying their RepNumber. Intended to be flipped on temporarily (trade shows) and off again — it only moves sync channels and never migrates data.
     * @param body Represents a request to turn a Sales Representative's org-wide customer visibility on or off.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SetViewAllCustomersRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ViewallcustomersRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/viewallcustomers";
/**
 * Metadata for all the requests in the request builder.
 */
export const ViewallcustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ViewallcustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSetViewAllCustomersResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSetViewAllCustomersRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
